const ForgotPassword = () => {
    return (
        <div>
            <h1>ForgotPassword</h1>
        </div>
    );
};

export default ForgotPassword;
